import React, {Fragment} from "react";
import Card from "../../../components/card/Card";
import ModalConfirm from "../../../components/ModalConfirm";
import ModalMsg from "../../../components/ModalMsg";
import NsDataTable from "../../../components/tabelle/NsDataTable";
import NsButtonActionsGroup from "../../../components/buttons/NsButtonActionsGroup";
import NsButtonAction from "../../../components/buttons/NsButtonAction";
import {Tag} from "primereact/tag";
import {getStrRgba} from "../../../utility/common";
import ModalUploadElementi from "../../../components/ModalUploadElementi";

export default function ConfKpiView({
                                        kpi,
                                        frequenze,
                                        macrocategorie,
                                        classiImpExp,
                                        kpiSel,
                                        translate,
                                        onKpiDbClick,
                                        showConfirm,
                                        setShowConfirm,
                                        eliminaKpi,
                                        show,
                                        setShow,
                                        modalMsg,
                                        loadingData,
                                        isRuoloSuperAdmin,
                                        setKpiSel,
                                        bottoniDx,
                                        tipiKpi,
                                        setShowModalUploadKpi,
                                        showModalUploadKpi,
                                        updateDati,
                                        token,
                                    }) {

    return (
        <Card
            icon={'fas fa-table'}
            title={'KPI'}
            bottoniDx={bottoniDx}
        >
            <ModalConfirm
                show={showConfirm}
                handleClose={() => setShowConfirm(false)}
                handleOk={eliminaKpi}
                testo={"Sicuro di voler eliminare il KPI: " + (kpiSel && kpiSel.codice) + "?"}/>
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            <ModalUploadElementi
                titolo={"Upload ESRS"}
                endopoint={process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/template-import/`}
                show={showModalUploadKpi}
                translate={translate}
                token={token}
                handleClose={() => {
                    setShowModalUploadKpi(false);
                    updateDati();
                }}/>
            {
                !loadingData &&
                <Fragment>
                    <NsDataTable
                        data={kpi}
                        columns={[
                            {
                                name: translate('Codice'),
                                selector: row => row.codice,
                                sortable: true,
                                filtroHeader: {
                                    filterFunction: (item, filtro) => (item.codice && item.codice.toLowerCase().includes(filtro.toLowerCase()))
                                }
                            },
                            {
                                name: translate('Descrizione'),
                                selector: row => row.descrizione,
                                sortable: true,
                                filtroHeader: {
                                    filterFunction: (item, filtro) => (item.descrizione && item.descrizione.toLowerCase().includes(filtro.toLowerCase()))
                                }
                            },
                            {
                                name: translate('Frequenza compilazione'),
                                selector: row => row.frequenza_compilazione,
                                sortable: true,
                                filtroHeader: {
                                    filterFunction: (item, filtro) => (item.id_frequenza_compilazione == filtro),
                                    filterOptions: frequenze ? frequenze.map((f) => ({
                                        id: f.id_frequenza_compilazione,
                                        descrizione: f.descrizione
                                    })) : []
                                }
                            },
                            {
                                name: translate('Stato'),
                                selector: row => row.stato == '1' ?
                                    <Tag className="mr-2" icon="fas fa-check" severity="success"
                                         value={translate("Attivo")}/>
                                    :
                                    <Tag className="mr-2" icon="fas fa-times" severity="danger"
                                         value={translate("Non attivo")}/>,
                                sortable: true,
                                sortFunction: (a, b) => {
                                    return a.stato - b.stato;
                                },
                                filtroHeader: {
                                    filterFunction: (item, filtro) => (item.stato == filtro),
                                    filterOptions: [
                                        {
                                            id: '1',
                                            descrizione: translate('Attivo')
                                        },
                                        {
                                            id: '0',
                                            descrizione: translate('Non attivo')
                                        },
                                    ],
                                    statusItemTemplate: (option) => {
                                        if (option == translate("Attivo")) {
                                            return <Tag className="mr-2" icon="fas fa-check" severity="success"
                                                        value={translate("Attivo")}/>
                                        } else {
                                            return <Tag className="mr-2" icon="fas fa-times" severity="danger"
                                                        value={translate("Non attivo")}/>
                                        }
                                    }
                                }
                            },
                            {
                                name: translate('Struttura KPI'),
                                selector: row => row.kpi_macrocategoria_codice + ' - ' +row.kpi_macrocategoria,
                                sortable: true,
                                filtroHeader: {
                                    filterFunction: (item, filtro) => (item.id_kpi_macrocategoria == filtro),
                                    filterOptions: macrocategorie ? macrocategorie.map((m) => ({
                                        id: m.id_kpi_macrocategoria,
                                        descrizione: m.codice + ' - ' + m.descrizione
                                    })) : []
                                }
                            },
                            {
                                name: translate('Perimetro'),
                                selector: row => row.classe_tipo_imp_dati,
                                sortable: true,
                                filtroHeader: {
                                    filterFunction: (item, filtro) => (item.id_classe_tipo_imp_dati == filtro),
                                    filterOptions: classiImpExp ? classiImpExp.map((c) => ({
                                        id: c.id_classe_tipo_imp_exp,
                                        descrizione: c.descrizione
                                    })) : []
                                }
                            },
                            {
                                name: translate('Tipo export dati'),
                                selector: row => row.classe_tipo_exp_dati,
                                sortable: true,
                                filtroHeader: {
                                    filterFunction: (item, filtro) => (item.id_classe_tipo_exp_dati == filtro),
                                    filterOptions: classiImpExp ? classiImpExp.map((c) => ({
                                        id: c.id_classe_tipo_imp_exp,
                                        descrizione: c.descrizione
                                    })) : []
                                }
                            },
                            {
                                name: translate('Configurato'),
                                selector: row => row.configurato && parseInt(row.configurato) === 1 ?
                                    <Tag className="mr-2" icon="fas fa-check" severity="success"
                                         value={translate("Configurato")}/>
                                    :
                                    <Tag className="mr-2" icon="fas fa-times" severity="danger"
                                         value={translate("Non configurato")}/>,
                                sortable: true,
                                sortFunction: (a, b) => {
                                    return a.configurato - b.configurato;
                                },
                                filtroHeader: {
                                    filterFunction: (item, filtro) => (item.configurato == filtro),
                                    filterOptions: [
                                        {
                                            id: '1',
                                            descrizione: translate('Configurato')
                                        },
                                        {
                                            id: '0',
                                            descrizione: translate('Non configurato')
                                        },
                                    ],
                                    statusItemTemplate: (option) => {
                                        if (option == translate("Configurato")) {
                                            return <Tag className="mr-2" icon="fas fa-check" severity="success"
                                                        value={translate("Configurato")}/>
                                        } else {
                                            return <Tag className="mr-2" icon="fas fa-times" severity="danger"
                                                        value={translate("Non configurato")}/>
                                        }
                                    }
                                }
                            },
                            {
                                name: translate('Tipo'),
                                selector: row => <Tag
                                    className="mr-2"
                                    value={translate(row.tipo_kpi_descr)}
                                    style={{
                                        backgroundColor: getStrRgba(row.colore_tipo_kpi),
                                    }}
                                />,
                                sortable: true,
                                filtroHeader: {
                                    filterFunction: (item, filtro) => (item.tipo_kpi == filtro),
                                    filterOptions: tipiKpi ? tipiKpi.map((t) => ({
                                        id: t.id_tipo_kpi,
                                        descrizione: t.descrizione
                                    })) : [],
                                    statusItemTemplate: (option) => {
                                        let optFiltrata = tipiKpi.filter((opt) => opt.descrizione == option);
                                        if (optFiltrata && optFiltrata.length > 0) {
                                            return (
                                                <Tag value={optFiltrata[0].descrizione}
                                                     className="mr-2"
                                                     style={{
                                                         backgroundColor: getStrRgba(optFiltrata[0].colore),
                                                     }}
                                                />
                                            );
                                        }
                                    }
                                }
                            },
                            {
                                name: translate('Ordine'),
                                selector: row => row.ordine,
                                sortable: true,
                            },
                            {
                                name: translate('Ordine export dati'),
                                selector: row => row.ordine_exp_dati,
                                sortable: true,
                            },
                            {
                                name: '',
                                selector: row => <NsButtonActionsGroup>
                                    <li>
                                        <NsButtonAction
                                            href={"/upd-kpi/" + row.id_kpi}
                                            label={"Modifica"}
                                            icona={"fas fa-pen"}
                                        />
                                    </li>
                                    {
                                        isRuoloSuperAdmin() &&
                                        <li>
                                            <NsButtonAction
                                                label={"Elimina"}
                                                icona={"fas fa-trash"}
                                                onClick={() => {
                                                    setKpiSel(row)
                                                    setShowConfirm(true);
                                                }}
                                            />
                                        </li>
                                    }
                                </NsButtonActionsGroup>,
                                sortable: false,
                                right: true,
                            }
                        ]}
                        onRowDbClick={onKpiDbClick}
                    />
                </Fragment>
            }
        </Card>
    );
}
